import React, { useEffect } from 'react'

import { formatTitle } from 'core/helpers/wp-data-helpers'

const withView = Component => {
  return props => {
    useEffect(() => {
      if (props.title || props.title === '') {
        document.title = formatTitle(props.title)
      }
    }, [])

    return <Component {...props} className={`routes-view ${props.className || ''}`}></Component>
  }
}

export default withView
